/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import vn8 from "../../assets/images/flag/vn8.png";
import en8 from "../../assets/images/flag/eng8.png";

const NavbarBottom = () => {
  const { t, i18n } = useTranslation();

  const currentDate = new Date();

  // Đổi ngôn ngữ = đổi prefix /en <-> /vi trên URL.
  // LƯU Ý: basename của BrowserRouter được set cố định theo ngôn ngữ tại thời
  // điểm mount (xem App.jsx), nên navigate() của react-router sẽ tự ghép
  // basename cũ vào trước path mới -> không đổi được ngôn ngữ đúng cách.
  // Phải dùng full page reload để Router mount lại với basename mới.
  const handleChangeLanguage = (language) => {
    const newPath = window.location.pathname.replace(
      /^\/(en|vi)/,
      `/${language}`,
    );
    window.location.href = `${newPath}${window.location.search}${window.location.hash}`;
  };

  const handleOpenMenuBottom = (e) => {
    e.preventDefault();
    document.getElementById("openDropupMenuBottom").classList.toggle("open");
  };

  useEffect(() => {
    const handleResize = () => {
      document.getElementById("openDropupMenuBottom")?.classList.remove("open");
    };
    const handleClick = (e) => {
      if (!e.target.closest("#dropupMenuBottom")) {
        document.getElementById("openDropupMenuBottom")?.classList.remove("open");
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("click", handleClick);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <nav className="navbar margin-bottom-0 footer-bot-bg footer-nav">
      <div className="container px-md-0">
        <div className="col-md-4 px-md-0 pt-4 col-xs-12 justify-md-center"></div>

        <div className="col-md-6 px-md-0 pt-1 col-xs-12 justify-md-center">
          <ul className="nav footer-nav__lists ">
            <li className="font-14 font-xs-12" style={{ textAlign: "center" }}>
              Copyright © 2025 - {currentDate.getFullYear()}{" "}
              <a
                href="https://quantera.vn/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
                style={{
                  display: "contents",
                  color: "inherit",
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                }}
              >
                Quantera
              </a>
              {""} - {t("navbar-footer.content")}
            </li>
          </ul>
        </div>

        {/* <div className="col-md-2 px-md-0 col-xs-12 justify-md-center">
          <div id="openDropupMenuBottom" className="drop-up">
            <a
              id="dropupMenuBottom"
              aria-haspopup="true"
              aria-expanded="true"
              className="navbar__links__link_language footer-nav__lists--right"
              href="#"
              onClick={handleOpenMenuBottom}
              role="button"
            >
              {i18n.language === "en" ? (
                <div className="flex mw-105">
                  <img src={en8} alt="en8" />
                  <span className="pt-4 ml-5">English</span>
                  <i className="fa fa-angle-up"></i>
                </div>
              ) : (
                <div className="flex mw-105">
                  <img src={vn8} alt="vn8" />
                  <span className="pt-4 ml-5">Tiếng Việt</span>
                  <i className="fa fa-angle-up"></i>
                </div>
              )}
            </a>
            <ul className="dropup-language-menu change-language-dropup">
              <li className="mb-5">
                <div className="flex">
                  <a
                    href="#"
                    className="font-14"
                    onClick={(e) => {
                      e.preventDefault();
                      handleChangeLanguage("en");
                    }}
                  >
                    <img src={en8} alt="en8" />
                    <span className="pt-4 ml-5">English</span>
                  </a>
                </div>
              </li>
              <li>
                <div className="flex">
                  <a
                    href="#"
                    className="font-14"
                    onClick={(e) => {
                      e.preventDefault();
                      handleChangeLanguage("vi");
                    }}
                  >
                    <img src={vn8} alt="vn8" />
                    <span className="pt-4 ml-5">Tiếng Việt</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div> */}
      </div>
    </nav>
  );
};

export default NavbarBottom;